export const faqs = [
  {
    id: "uyelik",
    question: "Üyelik",
    answer:
      "Üyelik ücretsizdir. Ana sayfadaki 'KAYIT OL' seçeneğine tıklayarak kayıt olabilirsiniz.",
  },
  {
    id: "iptal-degisim",
    question: "İptal ve Değişim",
    answer:
      "Ürün iadeleri için, faturada belirtilen adrese veya belirtilmemişse belirli bir adrese ürünü gönderebilirsiniz. Değişim yapılmamaktadır.",
  },
  {
    id: "kargo-teslimat",
    question: "Kargo ve Teslimat",
    answer:
      "Siparişiniz, belirtilen adreslere diğer anlaşmalı kargo firmalarımız aracılığıyla teslim edilir. Siparişinizin durumunu 'Hesabım' altından takip edebilirsiniz.",
  },
  {
    id: "siparis",
    question: "Sipariş",
    answer:
      "Sipariş durumunuzu, değişiklik veya iptal işlemlerinizi 'Hesabım' üzerinden yönetebilirsiniz.",
  },
  {
    id: "odeme",
    question: "Ödeme",
    answer:
      "Kapıda ödeme, banka veya kredi kartı ile ödeme seçeneklerimiz mevcuttur. Taksit seçenekleri için kredi kartınızı kullanabilirsiniz.",
  },
  {
    id: "indirim-kuponlari",
    question: "İndirim Kuponları ve Kodları",
    answer:
      "Sepet özetinin altında yer alan alana indirim kodunuzu girebilirsiniz. Bazı butiklerimiz indirimlere kapalıdır.",
  },
  {
    id: "fatura",
    question: "Fatura",
    answer:
      "Faturalar, sipariş sırasında belirttiğiniz adrese gönderilir",
  },
  {
    id: "hesabim",
    question: "Hesabım",
    answer:
      "Şifre ve e-posta adresi güncellemelerinizi 'Hesabım' üzerinden yapabilirsiniz.",
  },
  {
    id: "sikayet-oneri",
    question: "Şikayet ve Öneriler",
    answer:
      "Şikayetlerinizi mesai saatlerinde çağrı merkezimize iletebilirsiniz.",
  },
];